import {FileWithPath} from 'react-dropzone';
import {InferType, mixed, number, object, string} from 'yup';

export const v8nSchema = object().shape({
  slug: string().required(),
  name: string().required(),
  description: string().required(),
  logoFile: mixed<FileWithPath>().required().nullable(),
  bannerFile: mixed<FileWithPath>().required().nullable(),
  order: number().integer().min(0).defined(),
});

export type FormValues = InferType<typeof v8nSchema>;
